module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAA4ElEQVRIS+1W2w3CMBCzJwAmADZgFEboBsAEwAZlA1Zig3aDdoJDTsMHqGpz+egHyv0kH2dZuod9NLMjgCuAA+ajAXAn+VSqmVURu5uHQtgLzUyfbQLgk9KQ3EdCP9bMzEEWUkkyEvqxhXCs3KWkU0OotfBPWpnSiZrmKE1Pch0XvwOwcghHK0Lp4S1R3noANUnlS0v1nhNJW/EEiVoylid0Wox69vgp6QlA6OlMDNaWYU8dyU3m0DRl8UfbUtyiuMX/+6H3mG1Jhks7Q6VeUhqd+nWiPQ0W833qp1qbsNUbt5Hke2DWeG0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/course/icon-6.png
// module id = nu3a
// module chunks = 96